import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { firebaseApp } from "./firebase";
import imageCompression from "browser-image-compression";
import { uid } from "uid";


const storage = getStorage(firebaseApp);


export const uploadPhoto = async (image, imageId) => {
  const id = imageId || uid();
  const storageRef = ref(storage, `images/${id}`);
  const metadata = {
    contentType: "image/jpeg",
  };

  return uploadBytes(storageRef, image, metadata).then((snapshot) => {
    return getDownloadURL(snapshot?.ref).then((imageLink) => {
      return { id: id, link: imageLink };
    });
  });
};

export const uploadVideo = async (video, videoId) => {
  const id = videoId || uid();
  const storageRef = ref(storage, `video_files/${id}`);
  const metadata = {
    contentType: "video/mp4",
  };
  return uploadBytes(storageRef, video, metadata).then((snapshot) => {
    return getDownloadURL(snapshot?.ref).then((videoLink) => {
      return { id: id, link: videoLink };
    });
  });

};

export const handleImageUpload = async (imageFile, id) => {
  if (imageFile) {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(imageFile, options);
      return uploadPhoto(compressedFile, id).then((res) => {
        return res;
      });
    } catch (error) {
      console.log(error);
    }
  }
};

export const deleteImage = async (id) => {
  const imageRef = ref(storage, `images/${id}`);
  await deleteObject(imageRef);
};

export const deleteVideoFile = async (id) => {
  const videoRef = ref(storage, `video_files/${id}`);
  await deleteObject(videoRef);
};
